<template>
  <v-card
    class="elevation-7 mx-auto pa-4 pt-7 rounded-lg"
    style="max-width: 460px; z-index: 1"
  >
    <h2
      class="font-weight-bold font-weight-light mb-6 text-center text-uppercase"
    >
      <LawLabIcon class="app-icon" />
      LawLab
    </h2>

    <div
      v-if="isLoadingScreenVisible"
      key="loading-screen"
      class="align-center d-flex flex-column"
    >
      <v-progress-circular
        indeterminate
        color="primary"
        size="64"
      />

      <div class="my-4">
        Loading, please wait ...
      </div>
    </div>

    <LoginForm
      v-if="isLoginScreenVisible"
      key="login-screen"
      @on-open-account-recovery="_ => showAccountRecoveryScreen()"
      @on-open-account-verification="_ => showAccountVerificationScreen()"
      @on-close-auth-dialog="_ => onCloseLoginForm()"
    />

    <AccountRecovery
      v-if="isAccountRecoveryScreenVisible"
      key="account-recovery-screen"
      @on-close="_ => showLoginScreen()"
    />

    <ResetPassword
      v-if="isResetPasswordScreenVisible"
      key="reset-password-screen"
      @on-close="_ => showLoginScreen()"
    />

    <AccountVerification
      v-if="isAccountVerificationScreenVisible"
      key="account-verification-screen"
      @on-close="_ => showLoginScreen()"
    />
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import { AUTHENTICATION_NAMESPACE } from '@/store/authentication'

import AccountRecovery from '@/components/Authentication/AccountRecovery.vue'
import AccountVerification from '@/components/Authentication/AccountVerification.vue'
import LawLabIcon from '@/components/Icons/LawLabIcon.vue'
import LoginForm from '@/components/Authentication/LoginForm.vue'
import ResetPassword from '@/components/Authentication/ResetPassword.vue'

const Screens = {
  AccountRecoveryScreen: 2,
  AccountVerificationScreen: 3,
  LoadingScreen: 0,
  LoginScreen: 1,
  ResetPasswordScreen: 4,
  VerifyAccountScreen: 5,
}

export default {
  name: 'AuthenticationForms',

  components: {
    AccountRecovery,
    AccountVerification,
    LawLabIcon,
    LoginForm,
    ResetPassword,
  },

  data () {
    return {
      currentScreen: Screens.LoadingScreen,
    }
  },

  computed: {
    isAccountRecoveryScreenVisible () {
      return this.currentScreen === Screens.AccountRecoveryScreen
    },

    isAccountVerificationScreenVisible () {
      return this.currentScreen === Screens.AccountVerificationScreen
    },

    isLoadingScreenVisible () {
      return this.currentScreen === Screens.LoadingScreen
    },

    isLoginScreenVisible () {
      return this.currentScreen === Screens.LoginScreen
    },

    isResetPasswordScreenVisible () {
      return this.currentScreen === Screens.ResetPasswordScreen
    },

    ...mapGetters([
      'isLoggedIn',
    ]),
  },

  async created () {
    this.showLoadingScreen()
    await this.loadMultifactorAuthenticationSettings()

    // don't load this view if user is logged in
    if (this.isLoggedIn) {
      if (!this.isSessionInactive) this.$router.push('/')
    } else if (this.$route.query.rtoken) {
      this.showResetPasswordScreen()
    } else if (this.$route.query.vtoken) {
      this.showAccountVerificationScreen()
    } else {
      this.showLoginScreen()
    }
  },

  methods: {
    onCloseLoginForm () {
      this.$emit('on-close-auth-dialog')
    },

    showAccountRecoveryScreen () {
      this.currentScreen = Screens.AccountRecoveryScreen
    },

    showAccountVerificationScreen () {
      this.currentScreen = Screens.AccountVerificationScreen
    },

    showLoadingScreen () {
      this.currentScreen = Screens.LoadingScreen
    },

    showLoginScreen () {
      this.currentScreen = Screens.LoginScreen
    },

    showResetPasswordScreen () {
      this.currentScreen = Screens.ResetPasswordScreen
    },

    ...mapActions(AUTHENTICATION_NAMESPACE, [
      'loadMultifactorAuthenticationSettings',
    ]),
  },
}
</script>
